import { StencilComponentBuilder } from '../../helpers/stecil-component-builder';

type TableCell = {
  _uid: string;
  value: string;
  component: '_table_col';
};

type TableRow = {
  _uid: string;
  body: TableCell[];
  component: '_table_row';
};

type TableHeader = {
  _uid: string;
  value: string;
  component: '_table_head';
};

type Table = {
  thead: TableHeader[];
  tbody: TableRow[];
  fieldtype: 'table';
};

type RocheResponsiveTableBlok = {
  _uid: string;
  table: Table;
  sortable: boolean;
  component: 'roche-responsive-table';
  align_text: string;
  filterable: boolean;
  sticky_header: boolean;
  alternated_row: string;
  alternated_column: string;
  multiple_alternatives: string;
};

type RocheResponsiveTableProps = {
  getComponent: any;
  blok: RocheResponsiveTableBlok;
  slot?: string;
  storyId: number;
  [key: string]: any;
};

const RocheResponsiveTable = ({ blok, ...rest }: RocheResponsiveTableProps): JSX.Element | null => {
  if (!blok.table) {
    return null;
  }

  const headersArray = blok.table.thead.map((tableHeader) => tableHeader.value);

  const rowsArray = blok.table.tbody.map((tableRow) => tableRow.body.map((tableCell) => tableCell.value));

  return StencilComponentBuilder({
    blok: {
      ...blok,
      table: undefined,
      headers: headersArray,
      rows: rowsArray,
    },
    ...rest,
  });
};

export const responsiveTable = {
  'roche-responsive-table': RocheResponsiveTable,
};
